import {Box, Tab, Typography} from "@mui/material";
import {connect} from "react-redux";
import {selectConfig} from "../../../redux/selectors/firebase";
import {SyntheticEvent, useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {VideoJobs} from "./VideoJobs";
import {VideoEncoding} from "./VideoEncoding";
import {VideoResources} from "./VideoResources";
import {VideoExportDetails} from "./VideoExportDetails";
import {SoundConfig} from "./SoundConfig";
import {AssetCache} from "./AssetCache";
import {ProjectDetails} from "../../../redux/types/firebase";

const useScriptStyles = makeStyles(theme => ({
    tabs: {
        display: 'flex',
        flexDirection: "column",
        height: "100%",
        width: "100%",
    },
    tabPanels: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "calc(100% - 48px)"
    },
    tabPanel: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: "calc(100% - 48px)"
    },
}));
export const codecs = ["h264", "h265"];
export const platforms = ["android", "ios", "osx", "win32"];
export const resolutions = ["480p", "720p", "1080p", "1440p"];

interface IAssetsConfig {
    config: any
    project: string
    projects: {[project: string]: ProjectDetails}
}
function AssetsConfig({config, project, projects}: IAssetsConfig) {
    const [tab, setTab] = useState("videoJobs");
    const classes = useScriptStyles();
    const handleTabChange = (event: SyntheticEvent, value: any) => setTab(value);

    if (! config) {
        return (
            <Box display="flex">
                <Typography color="error">
                    Warning. There are no configuration settings for this project - this means that the build service
                    will be unable to process your data and you are unlikely to see any videos or sounds working in the
                    project. To set up the project update the settings in the open project dialog within Cookbook.
                </Typography>
            </Box>
        );
    }
    return (
        <TabContext value={tab}>
            <Box className={classes.tabs}>
                <TabList onChange={handleTabChange}>
                    <Tab label="Asset Cache" value="assetCache"/>
                    <Tab label="Video Jobs" value="videoJobs"/>
                    <Tab label="Video Encoding" value="videoEncoding"/>
                    <Tab label="Video Resources" value="videoResources"/>
                    <Tab label="Video Export Details" value="videoExportDetails"/>
                    <Tab label="Sound" value="sound"/>
                </TabList>
                <Box className={classes.tabPanels}>
                    {tab === "assetCache" &&
                        <TabPanel className={classes.tabPanel} value="assetCache">
                            <AssetCache project={project} projects={projects}/>
                        </TabPanel>}
                    {tab === "videoJobs" &&
                        <TabPanel className={classes.tabPanel} value="videoJobs">
                            <VideoJobs config={config} project={project}/>
                        </TabPanel>}
                    {tab === "videoEncoding" &&
                        <TabPanel className={classes.tabPanel} value="videoEncoding">
                            <VideoEncoding config={config} project={project}/>
                        </TabPanel>}
                    {tab === "videoResources" &&
                        <TabPanel className={classes.tabPanel} value="videoResources">
                            <VideoResources config={config} project={project}/>
                        </TabPanel>}
                    {tab === "videoExportDetails" &&
                        <TabPanel className={classes.tabPanel} value="videoExportDetails">
                            <VideoExportDetails config={config} project={project}/>
                        </TabPanel>}
                    {tab === "sound" &&
                        <TabPanel className={classes.tabPanel} value="sound">
                            <SoundConfig config={config} project={project}/>
                        </TabPanel>}
                </Box>
            </Box>
        </TabContext>
    );
}
const mapStateToProps = (store: never) => ({
    config: selectConfig(store)
});
const connected = connect(mapStateToProps, {
})(AssetsConfig);

export {connected as AssetsConfig};
